/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tracking_Mode_LiveInputs */

const vi_tracking_mode_live = /** @type {(inputs: Tracking_Mode_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang theo dõi vị trí hiện tại`)
};

/**

* @param {Tracking_Mode_LiveInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const tracking_mode_live = /** @type {((inputs?: Tracking_Mode_LiveInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tracking_Mode_LiveInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_tracking_mode_live(inputs)
});